<script setup lang="ts">
// Import here (not via nuxt `css[]`) — vanilla-extract `.css.ts` in `css[]`
// emits an empty SSR module with no default export and breaks the Nitro build.
import '@pkg/ui/components/ui/theme/app.css.ts';
// Shared button recipe + `.button-text` / focus globals used by ButtonGroup.
import '@pkg/ui/components/ui/button/button.css.ts';
// Business host overrides (VE, not Tailwind).
import '~/assets/css/page.css.ts';
import '~/assets/css/typographyGlobals.css.ts';
import '~/assets/css/typographyUtilities.css.ts';
import '~/assets/css/sectionTheme.css.ts';
import '~/assets/css/wrapper.css.ts';
import '~/assets/css/buttonGroup.css.ts';
import '~/assets/css/mainHero.css.ts';
import '~/assets/css/subHeroSection.css.ts';
import '~/assets/css/titleBlock.css.ts';
import '~/assets/css/baseFooter.css.ts';
import '~/assets/css/partialHeader.css.ts';
import '~/assets/css/mobileNav.css.ts';
import '~/assets/css/headerActions.css.ts';
import '~/assets/css/navSubmenuList.css.ts';

const { meta } = useAppConfig();

useHead({
  meta: [
    { name: 'google-site-verification', content: meta.googleSiteVerification },
  ],
});
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
